const Shield = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.16797 3.9L13.0013 0V26C13.0013 26 2.16797 20.8 2.16797 13V3.9Z"
      fill="#61DE56"
    />
    <path
      d="M23.834 3.9L13.0007 0V26C13.0007 26 23.834 20.8 23.834 13V3.9Z"
      fill="#13C37B"
    />
  </svg>
);
export default Shield;
